const state = {
  // 是否要缓存页面，默认不缓存
  cacheable: false,

  visited:[],
  // 缓存的页面
  cached: []
}

const mutations = {
  ADD_TAG(state, data) {
    if (state.visited.some(v => v.path === data.path)) return

    if (state.cached.includes(data.name)) {
      console.error(`${data.name} 组件出现命名重复，请检查组件中的name字段。当前组件所在的路由地址为：${data.path}`)
      return
    }
    state.visited.push(data)
    if (state.cacheable) {
      state.cached.push(data.name)
    }
  },
  REMOVE_TAG(state, data) {
    if (data) {
      for (let [i, v] of state.visited.entries()) {

        if (v.path === data.path) {
          state.visited.splice(i, 1)
        }
      }

      if (state.cacheable) {
        let index = state.cached.indexOf(data.name)
        if (index >= 0) {
          state.cached.splice(index, 1)
        }
      }
    } else {
      state.visited = []
      state.cached = []
    }
  }
}

const actions = {
  add({ commit }, data) {
    commit('ADD_TAG', data)
  },
  remove({ commit }, data){
    return new Promise((resolve) => {
      commit('REMOVE_TAG', data)
      resolve([...state.visited])
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
